<template>
  <router-view />
</template>

<script>
export default {
  name: "NotificationManagement"
};
</script>
